import { useTrialsContext } from 'contexts/TrialsContextProvider';
import useToggleShowPassword from 'hooks/useToggleShowPassword';

import TrialFormField from './TrialFormField';

const PasswordField = ({
  placeholder = 'Password',
  variant = 'outline',
  ...props
}) => {
  const { iconProps, showPassword } = useToggleShowPassword();
  const { password, setPassword, accountInfoFieldProps } =
    useTrialsContext() || {};

  return (
    <TrialFormField
      fieldName="password"
      iconProps={iconProps}
      id="trial-password"
      omitTrackingValue
      placeholder={placeholder}
      setFieldValue={setPassword}
      type={showPassword ? 'text' : 'password'}
      value={password}
      variant={variant}
      {...accountInfoFieldProps}
      {...props}
    />
  );
};

export default PasswordField;
